import type { SVGProps } from 'react';

const SvgArchiveArchive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 3.005h-7c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1 .45 1 1v5H9c0-.55-.45-1-1-1s-1 .45-1 1v7c0 1.65 1.35 3 3 3h8c1.65 0 3-1.35 3-3v-12c0-1.65-1.35-3-3-3m0 16h-8c-.55 0-1-.45-1-1v-5h10v5c0 .55-.45 1-1 1"
    />
    <path
      fill="currentcolor"
      d="M16 15.005h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1m0-6c.55 0 1-.45 1-1s-.45-1-1-1h-5c-.55 0-1 .45-1 1s.45 1 1 1zm-8.62-1.08a1 1 0 0 0 .54-.53c.05-.12.08-.25.08-.38v-3.01c0-.55-.45-1-1-1s-1 .45-1 1v.59l-1.29-1.3c-.39-.39-1.03-.39-1.42 0s-.39 1.03 0 1.42l1.29 1.29h-.59c-.55 0-1 .45-1 1s.45 1 1 1h3c.13 0 .26-.03.38-.08z"
    />
  </svg>
);
export default SvgArchiveArchive;
